// extracted by mini-css-extract-plugin
export default {"container":"zR-z","modal":"AR-z","dimensions":"BR-z","brandName":"CR-z","productName":"DR-z","labelValue":"ER-z","recipientEmail":"FR-z","recommendedFit":"GR-z","hiddenField":"HR-z"};